export const    LOGIN_VALIDATE = "LOGIN_VALIDATE",
                LOGOUT_REQUEST = "LOGOUT_REQUEST",
                LOGOUT_SUCCESS = "LOGOUT_SUCCESS",
                LOGOUT_FAILURE = "LOGOUT_FAILURE",
                LOGIN_REQUEST = "LOGIN_REQUEST",
                LOGIN_SUCCESS = "LOGIN_SUCCESS",
                LOGIN_FAILURE = "LOGIN_FAILURE",
                GET_USER_REQUEST = "GET_USER_REQUEST",
                RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST",
                RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS",
                RESET_PASSWORD_UPDATE_REQUEST = "RESET_PASSWORD_UPDATE_REQUEST",
                RESET_PASSWORD_UPDATE_SUCCESS = "RESET_PASSWORD_UPDATE_SUCCESS",
                RESET_PASSWORD_UPDATE_FAILURE = "RESET_PASSWORD_UPDATE_FAILURE",
                NO_LOGIN = "NO_LOGIN";

export function resetPasswordUpdateRequest(email, token, password) {
    return {
        type: RESET_PASSWORD_UPDATE_REQUEST,
        email,
        password,
        token
    };
}
export function resetPasswordUpdateSuccess(success) {
    return {
        type: RESET_PASSWORD_UPDATE_SUCCESS,
        success
    };
}
export function resetPasswordUpdateFailure(response) {
    return {
        type: RESET_PASSWORD_UPDATE_FAILURE,
        success: response.success
    };
}
export function resetPasswordRequest(email) {
    return {
        type: RESET_PASSWORD_REQUEST,
        email
    };
}
export function resetPasswordSuccess() {
    return {
        type: RESET_PASSWORD_SUCCESS
    };
}
export function loginValidate() {
    return {
        type: LOGIN_VALIDATE
    };
}
export function loginRequest(email, password, rememberMe) {
    return {
        type: LOGIN_REQUEST,
        email,
        password,
        rememberMe
    };
}
export function loginSuccess(userId, email, token) {
    return {
        type: LOGIN_SUCCESS,
        userId: userId,
        email: email,
        token: token
    };
}

export function getCurrentUserRequest(id) {
    return {
        type: GET_USER_REQUEST,
        id
    };
}
export function noLogin() {
    return {
        type: NO_LOGIN
    };
}

export function loginFailure(responseStatus) {
    return {
        type: LOGIN_FAILURE,
        responseStatus
    };
}


export function logoutRequest(email) {
    return {
        type: LOGOUT_REQUEST,
        email
    };
}
export function logoutSuccess() {
    return {
        type: LOGOUT_SUCCESS
    };
}
export function logoutFailure(responseStatus) {
    return {
        type: LOGOUT_FAILURE,
        responseStatus
    };
}



// WEBPACK FOOTER //
// ./src/actions/login.actions.ts